export default "/signup/_next/static/chunks/fonts/lineto-circular-medium-95d034968b15bf84e8d12d3e52fb2b05.eot";